import { useCallback, useEffect, useRef, useState } from "react";
import "./PortfolioScreenshotGallery.css";

/**
 * 업종별 포트폴리오 — 탭 선택 시 해당 스크린샷 1장만 표시
 */
export default function PortfolioScreenshotGallery({
  images,
  embed = false,
  accent = "#0e7490",
  onActiveChange,
  testId = "portfolio-screenshot-gallery",
  ariaLabel = "포트폴리오",
  panelPrefix = "portfolio-shot",
}) {
  const viewportRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const active = images[activeIndex] ?? images[0];
  const onActiveChangeRef = useRef(onActiveChange);
  onActiveChangeRef.current = onActiveChange;

  useEffect(() => {
    setActiveIndex(0);
    viewportRef.current?.scrollTo({ top: 0, behavior: "auto" });
  }, [images]);

  useEffect(() => {
    if (active) onActiveChangeRef.current?.(active);
  }, [active]);

  const selectIndex = useCallback((index) => {
    setActiveIndex(index);
    viewportRef.current?.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  if (!active) return null;

  return (
    <div
      className={`psg${embed ? " psg--embed" : ""}`}
      data-testid={testId}
      style={{ "--psg-accent": accent }}
    >
      <div className="psg__tabs" role="tablist" aria-label={ariaLabel}>
        {images.map((item, index) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={index === activeIndex}
            aria-controls={`${panelPrefix}-${item.id}`}
            className={`psg__tab${index === activeIndex ? " is-active" : ""}`}
            onClick={() => selectIndex(index)}
          >
            {item.title}
          </button>
        ))}
      </div>

      <div
        className="psg__viewport"
        ref={viewportRef}
        role="tabpanel"
        id={`${panelPrefix}-${active.id}`}
        aria-label={`${active.title} 홈페이지 제작 사례`}
      >
        <figure className="psg__figure">
          <img
            key={active.id}
            src={active.src}
            alt={`${active.title} 홈페이지 제작 사례`}
            className="psg__img"
            loading="eager"
            decoding="async"
          />
        </figure>
      </div>

      {!embed && (
        <p className="psg__hint">
          탭에서 업종별 제작 사례를 선택하세요 · 긴 화면은 스크롤로 확인할 수 있습니다.
        </p>
      )}
    </div>
  );
}
